import script from "./MyApplications.vue?vue&type=script&setup=true&lang=js"
export * from "./MyApplications.vue?vue&type=script&setup=true&lang=js"

import "./MyApplications.vue?vue&type=style&index=0&id=2ce7e578&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ce7e578"]])

export default __exports__